import { getCookie, setCookie, removeCookie } from 'typescript-cookie';

const INVITED_FROM_COOKIE = process.env.REACT_APP_COOKIE_INVITED_FROM;
const INVITED_FROM_EXPIRY_DAYS = process.env.REACT_APP_COOKIE_INVITED_FROM_EXPIRY_DAYS;
const INVITED_FROM_STORAGE_KEY = 'promotify_invited_from';

export const getInvitedFromCookie = () =>{
  const cookieValue = INVITED_FROM_COOKIE ? getCookie(INVITED_FROM_COOKIE) : undefined;
  if (cookieValue && cookieValue.length > 0) return cookieValue;

  const storageValue = typeof window !== 'undefined'
      ? window.localStorage.getItem(INVITED_FROM_STORAGE_KEY)
      : undefined;

  return storageValue && storageValue.length > 0 ? storageValue : undefined;
}

export const setInvitedFromCookie = (invitedFrom: string) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(INVITED_FROM_STORAGE_KEY, invitedFrom);
  }

  if(!INVITED_FROM_COOKIE || !INVITED_FROM_EXPIRY_DAYS) return;

  setCookie(INVITED_FROM_COOKIE, invitedFrom, { path: '/', expires: Number(INVITED_FROM_EXPIRY_DAYS), sameSite: 'lax' });
}

export const clearInvitedFromCookies = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(INVITED_FROM_STORAGE_KEY);
  }

  if(!INVITED_FROM_COOKIE) return;

  removeCookie(INVITED_FROM_COOKIE, { path: '/' });
}
